import * as React from 'react';
import classNames from 'classnames';
import { BookBenefit } from 'app/bookDetail';
import { Icon } from '@ridi/rsg';

export const NoticeBenefitItem = ({ url, title, detail_message }: BookBenefit) => {
  return (
    <li className={classNames('BookDetailNotice_List_Item')}>
      <a href={url}>
        <div className="BookDetailNotice_List_Item_Title">{title}</div>
        {detail_message.length > 0 && (
          <div className={classNames(
            'BookDetailNotice_List_Item_Content',
            'BookDetailNotice_List_Item_EventPeriod',
            'BookDetailNotice_List_Item_BookBenefit'
          )}>
            <span>
              {detail_message}
            </span>
          </div>
        )}
        <Icon
          className="BookDetailNotice_List_Item_ArrowIcon"
          name="arrow_2_right"
        />
      </a>
    </li>
  )
}

export type { BookBenefit };



// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/items/NoticeBenefitItem.tsx